
















import Vue, {ComponentOptions} from 'vue';
import { Component, Inject, Ref } from 'vue-property-decorator';

import { IConfig } from './models';

@Component({
  components: {
  },
})
export default class App extends Vue implements ComponentOptions<Vue> {

  public customerId: string | null = null;
  public customerToken: string | null = null;

  @Ref('form') private readonly formRef!: HTMLElement;

  @Inject('config')
  private readonly config!: IConfig;

  public async mounted(): Promise<void> {

    const {customerId, token} = (this.$root as any).getCredentials();

    if (!customerId || !token) {
      document.body.classList.add('error');
      return;
    }

    this.customerId = customerId;
    this.customerToken = token;
  }
}
